import { AddGeoLocationComponent} from './add-geolocation/add-geolocation.component';
import { EditGeoLocationComponent} from './edit-geolocation/edit-geolocation.component';
import { ViewGeoLocationComponent} from './view-geolocation/view-geolocation.component'

export const GeoLocationRouting: any = [
    { path: '', redirectTo: 'view-geolocation', pathMatch: 'full' },
    { path: 'add-geolocation', component: AddGeoLocationComponent},
    { path: 'view-geolocation', component: ViewGeoLocationComponent},
    { path: 'edit-geolocation/:branchID', component: EditGeoLocationComponent},
    
];

export const GeoLocationRoutingBreadcrumbs = [
    { name: 'Edit', path: '/edit-geolocation' },
    { name: 'Add', path: '/add-geolocation' },

];